import { createSelector } from '@ngrx/store';
import { CollectionsState, getCollectionsState } from '../collections.reducer';
import { usersAdapter, UsersState } from './users.reducer';
import { SubType } from '@app/shared/models/sub-type';

export const getUsersState = createSelector(
  getCollectionsState,
  (state: CollectionsState) => state?.users,
);

export const { selectEntities: getUsersEntities, selectAll: getAllUsers } =
  usersAdapter.getSelectors(getUsersState);

export const getLoggedInUser = createSelector(
  getUsersState,
  (state: UsersState) => state?.loggedInUser,
);

export const getEmailSignature = createSelector(
  getUsersState,
  (state: UsersState) => !!state && state.signature,
);

export const getUserSubscriptionType = createSelector(
  getUsersState,
  (state: UsersState) => state?.subscriptionType,
);

export const getIsUserSubscriptionTypeLoaded = createSelector(
  getUsersState,
  (state: UsersState) => !!state?.subscriptionTypeLoaded,
);

export const getUserSubscriptionDetails = createSelector(
  getUsersState,
  (state: UsersState) => state?.subscriptionDetails,
);

export const getTrialDaysLeft = createSelector(
  getUsersState,
  (state: UsersState) => state?.trialDaysLeft,
);

export const getIsUserOnPricingPage = createSelector(
  getUsersState,
  (state: UsersState) => state?.isUserOnPricingPage,
);

export const getIsUserOnTrial = createSelector(
  getUserSubscriptionType,
  (subscriptionType) => subscriptionType?.type === SubType.TRIAL,
);

export const getTrialDurationInDays = createSelector(
  getUsersState,
  (state: UsersState) => state?.trialDurationInDays,
);

export const getOwnerUsers = createSelector(
  getUsersState,
  (state: UsersState) => state?.ownerUsers,
);

export const getCustomerId = createSelector(
  getUserSubscriptionType,
  (subscriptionType) => subscriptionType?.customerId ?? null,
);

export const getCreditsLimitations = createSelector(
  getUsersState,
  (state: UsersState) => state?.creditsLimitations,
);

export const getMaxCredits = createSelector(
  getUsersState,
  (state: UsersState) => state?.creditsMaxLimit,
);
